import { PerformerRequest } from '@silbo/core';

export const getRequestReason = (request: PerformerRequest) => {
  if (request.request.visit?.thesaurusItem) {
    return request.request.visit.thesaurusItem.reason;
  }
  return request.request.visit?.admitReason;
};
